export default {
  announcement: {
    createAnnouncement: {
      newAnnouncement: "Create new announcement",
      back: "Back",
      title: "Title",
      titleLabel: "Enter title here",
      description: "Content description",
      descriptionLabel: "Enter description",
      button: {
        cancel: "Cancel",
        save: "Save and continue",
      },
      startDate: "Start date",
      endDate: "End date",
      Datenote:
        "Do not select End date to keep announcement online indefinately",
      showText: "Show Text editor",
      showRaw: "Show Raw",
      status: "Status",
      category: "Category",
      successMessage: "Your announcement is successfully saved.",
    },
    editAnnouncement: {
      title: "Edit announcement",
      button: {
        delete: "Delete",
      },
      deleteModal: {
        content:
          "Are you sure you want to delete this announcement permanently? <br /> <br/> You will not be able to undo this action if you choose to continue.",
        title: "Confirm delete",
        yesDelete: "Yes, delete",
      },
      previewAnnouncement: "Preview announcement",
    },
    announcementList: {
      title: "Announcement List",
      filters: {
        search: "Search",
        placeholders: {
          startDate: "Start date",
          endDate: "End date",
          title: "Search by title keyword",
          status: "Status",
        },
      },
      add: "Create new",
      table: {
        columns: {
          title: "Title",
          category: "Category",
          startDate: "Start date",
          endDate: "End date",
          status: "Status",
        },
      },
    },
  },
};
